/* eslint-disable react/no-danger */
import Head from 'next/head'
import React, { FC } from 'react'

import { useClientConfig } from '@Globals/Config/Provider'

import { gtmInit } from './GTM'

type DataLayerInput = Record<string, any>

interface DataLayerProps {
  input: DataLayerInput
}

// Needed on its own to ensure google's tag assistant tracks it properly
export const DataLayerInit = () => (
  <script
    key="datalayer-head"
    dangerouslySetInnerHTML={{ __html: 'dataLayer = [];' }}
    type="text/javascript"
  />
)

// Used to push input to window.dataLayer
// Also ensures tag manager is initialized after first defining window.dataLayer
// Must be called outside of next/head
export const DataLayer: FC<DataLayerProps> = (
  {
    input,
  }: DataLayerProps,
) => {
  const { googleTagManagerKey } = useClientConfig()

  return (
    <Head>
      <script
        dangerouslySetInnerHTML={{ __html: `dataLayer.push(${JSON.stringify(input)});` }}
        type="text/javascript"
      />
      <script
        key="gtm-init"
        dangerouslySetInnerHTML={{ __html: gtmInit(googleTagManagerKey) }}
        type="text/javascript"
      />
    </Head>
  )
}

export const generateEventID = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  // eslint-disable-next-line no-bitwise
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  // eslint-disable-next-line no-bitwise
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}`
}

// TODO: replace with actual interfaces instead of this catch-all
interface GTMData {
  ConsentAllServices?: boolean
  StoreAdsConversionID?: string
  StoreAdsConversionLabel?: string
  StoreAdsCurrency?: string
  StoreAdsValue?: number
  categoryContentIds?: string
  categoryIds?: string | number[]
  couponCode?: string
  customerEmail?: string
  customerPhone?: string
  event?: string
  identifyingLabel?: string
  moduleKey?: string
  productData?: {
    id?: string
    localPrice?: number
  }
  productId?: number
  productIds?: number[]
  productName?: string
  purchase?: {
    orderInfo?: {
      currency?: string
      localRevenue?: number
      localShippingCost?: number
      orderId?: string
      profit?: number
      profitInDKK?: number
    }
    purchasedProducts?: {
      categories?: string
      id?: string
      localPrice?: number
      quantity?: number
      title?: string
    }[]
  }
  timeUsed?: string
  trackingEventName?: any
}

export const gtm = (event: GTMData) => {
  if (typeof window === 'undefined') {
    return
  }
  const win = (window as any)
  win.dataLayer.push(event)
}
